import { Grid, Typography } from '@mui/material'
import { ReactNode } from 'react'

// Shared label/value layout primitives for the read-only merchant tabs (Details and Promotions).
export const PageSection = ({ children }: { children: ReactNode }) => {
  return (
    <Grid container spacing={2} size={12} marginBottom={2}>
      {children}
    </Grid>
  )
}

export const SectionTile = ({ title }: { title: string }) => {
  return (
    <Grid size={12}>
      <Typography variant="h6" component="div">
        {title}
      </Typography>
    </Grid>
  )
}

export const PropValue = ({ label, value }: { label: string; value: ReactNode }) => {
  return (
    <>
      <Grid size={{ xs: 6, md: 3 }}>
        <Typography color="text.secondary">{label}</Typography>
      </Grid>
      <Grid size={{ xs: 6, md: 3 }}>
        <Typography>{value || ''}</Typography>
      </Grid>
    </>
  )
}
